import {Moment} from "moment";

const lang = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;

const shortMonthAndDayFormat = lang == "en-US" ? "M/D" : "DD/MM"

export function getShortMonthAndDay(d: Moment) {
  return d.format(shortMonthAndDayFormat)
}